import React from "react";

import GlobalSearch from "../GlobalSearch/GlobalSearch";

const MenuDialog = (props) => {
  const { item } = props;

  if (item.name === "search") {
    return <GlobalSearch>{props.children}</GlobalSearch>;
  }

  return null;
};

export default MenuDialog;
